import { Line } from 'vue-chartjs';
 
export default {
  extends: Line,
  props: ['labels', 'data'],
  methods: {
    render: function() {
      this.renderChart({
        labels: this.labels,
        datasets: [
          {
            data: this.data
          }
        ]
      },
      {
        responsive: true, 
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          yAxes: [{
            type: 'linear',
            ticks: {
              callback: value => `${value} %`,
            }
          }]
        },
        tooltips: {
          enabled: true,
          mode: 'single',
          callbacks: {
            label: item => `${item.yLabel} %`
          }
        },
      });
    }
  },
  watch: {
    data: function() {
      this._data._chart.destroy();
      this.render();
    }
  },
  mounted: function() {
    this.render();
  }
};



// WEBPACK FOOTER //
// ./src/components/OccupationGraph.js